module.exports = __webpack_public_path__ + "img/h3c.3517d379.svg";